import { ProtobufClient } from 'api/protobuf/protobuf-client';
import { goBackendApi } from 'hooks/api/httpApi';
import { mapEveryBigintIntoNumber } from 'utils/map-every-bigint-into-number';
import { ShopifyPlansResponse, ShopifyPlansResponseSchema } from '../../pb/responses/v1/shopify_plans_response_pb';

const getPlans = async (): Promise<ShopifyPlansResponse> => {
    const pbClient = new ProtobufClient(goBackendApi());
    return pbClient
        .getRequest(ShopifyPlansResponseSchema, '/api/v1/subscription/shopify/plans')
        .then((response) => mapEveryBigintIntoNumber(response) as ShopifyPlansResponse);
};

export default { getPlans };
